module.exports = "<div *ngIf=\"isLoading\" id=\"cover-spin\"> \n</div>\n\n"